import { z } from 'zod';
import type { SchemaType } from '$util/schema';
import { CmsRichTextSchema, CmsShortTextSchema } from '$cms/types';

export const defaultConfiguration = {
  excludePaths: [],
};

export const PricingTableSchema = {
  translatedEntities: z.object({
    makeModelColumn: CmsShortTextSchema,
    priceRangeColumn: CmsShortTextSchema,
    title: CmsShortTextSchema,
    description: CmsRichTextSchema,
    descriptionAdditionalSku: CmsRichTextSchema.optional(),
    getQuoteButtonText: CmsShortTextSchema,
    saveLabel: CmsShortTextSchema,
    footerText: CmsShortTextSchema,
    forText: CmsShortTextSchema,
  }),
  configuration: z
    .object({
      excludePaths: z.array(z.string()).optional(),
    })
    .default(defaultConfiguration),
  serverSideData: z
    .object({
      /**
       * This is the expanded list of ProductCollectionItem.sku (which can also be groups or bundles of SKUs)
       * into a list of single item product SKUs.
       */
      unitSkus: z.string().array(),
      pricesArray: z
        .object({
          makeName: z.string(),
          modelName: z.string(),
          sku: z.string(),
          skuName: z.string(),
          marketPrice: z.number().positive(),
          highestPrice: z.number().positive(),
          lowestPrice: z.number().positive(),
          saveAmount: z.number().positive(),
        })
        .array()
        .nonempty(),
    })
    .nullable(),
};

export type PricingTableTranslatedEntities = SchemaType<(typeof PricingTableSchema)['translatedEntities']>;
export type PricingTablesConfiguration = SchemaType<(typeof PricingTableSchema)['configuration']>;
export type PricingTableServerSideData = SchemaType<(typeof PricingTableSchema)['serverSideData']>;

export type PriceDataRow = NonNullable<PricingTableServerSideData>['pricesArray'][0];
/**
 * Non-empty PriceDataRow[]
 */
export type PriceDataRows = NonNullable<PricingTableServerSideData>['pricesArray'];
